/* markdown仕様について
   FIXME: markdown-itの独自プラグイン導入 (総ルビ): NFR-744
 cf. https://tracery.jp/s/29805caf45804f0fb691afc0a5de2f7c */

import { html5Media } from "./markdown-it-media"
import MarkdownIt from "markdown-it"
import MarkdownItUnderline from "markdown-it-underline"
import MarkdownItDeflist from "markdown-it-deflist"
import MarkdownItBr from "markdown-it-br"
import MarkdownItBracketedSpans from "markdown-it-bracketed-spans"
import MarkdownItAttrs from "./markdown-it-attrs"
import MarkdownItDiv from "markdown-it-div"
import MarkdownItImsize from "@patarapolw/markdown-it-imsize"
import MarkdownItMathjax3 from "markdown-it-mathjax3"
import MarkdownItAnaume from "./markdown-it-anaume"
import MarkdownItSouruby from "./markdown-it-souruby"
import MarkdownItRuby from "./markdown-it-ruby"
import MarkdownItTableWithoutTheadTbody from "./markdown-it-table-without-thead-tbody"

export const markdown = MarkdownIt({
    breaks: true
})
    .use(MarkdownItUnderline)
    .use(MarkdownItDeflist)
    .use(MarkdownItBr)
    .use(MarkdownItBracketedSpans)
    .use(MarkdownItAttrs)
    .use(MarkdownItDiv)
    // NOTE: html5Media 内部の Ruler 更新処理の都合上、必ず imsize の後に html5Media を指定する
    .use(MarkdownItImsize)
    .use(html5Media)
    .use(MarkdownItMathjax3)
    .use(MarkdownItAnaume)
    // NOTE: souruby は必ず ruby の前に指定する
    .use(MarkdownItSouruby)
    .use(MarkdownItRuby)
    .use(MarkdownItTableWithoutTheadTbody); // NFR-2152の変更を取り込む際に有効化
